import React from "react";
import { colorPicker, logErr } from "../common";
import { ButtonDefault } from "./Button";
import { DynamicButton } from "./DynamicButton";
import "../styles/masterStyles.css";

const buttonPicker = props => {
    switch (props.button) {
        case "DynamicButton":
            return (
                <DynamicButton
                    selected={props.selected}
                    variant={props.variant}
                    disabled={props.disabled}
                    disabledElevation={props.disabledElevation}
                    disableFocusRipple={props.disableFocusRipple}
                    endIcon={props.endIcon}
                    fullWidth={props.fullWidth}
                    href={props.href}
                    size={props.size}
                    startIcon={props.startIcon}
                    onClick={props.onClick}
                    trueColor={colorPicker(props.trueColor)}
                    falseColor={colorPicker(props.falseColor)}
                    trueClass={colorPicker(props.trueClass)}
                    className={props.className}
                >
                    {props.children} 
                </DynamicButton>
            );
        case "ButtonDefault":
            return (
                <ButtonDefault
                    className={props.className}
                    variant={props.variant}
                    disabled={props.disabled}
                    disabledElevation={props.disabledElevation}
                    disableFocusRipple={props.disableFocusRipple}
                    endIcon={props.endIcon}
                    fullWidth={props.fullWidth}
                    href={props.href}
                    size={props.size}
                    startIcon={props.startIcon}
                    onClick={props.onClick}
                    root={colorPicker(props.color)}
                >
                    {props.children}
                </ButtonDefault>
            );
        default:
            return (
                <ButtonDefault
                    className={props.className}
                    variant={props.variant}
                    disabled={props.disabled}
                    disabledElevation={props.disabledElevation}
                    disableFocusRipple={props.disableFocusRipple}
                    endIcon={props.endIcon}
                    fullWidth={props.fullWidth}
                    href={props.href}
                    size={props.size}
                    startIcon={props.startIcon}
                    onClick={props.onClick}
                    root={colorPicker(props.color)}
                >
                    {props.children}
                </ButtonDefault>
            );
    }
};

export const SaspButton = props => {
    return buttonPicker({
        className: props.className || "defaultButton",
        button: props.button,
        color: props.color || "primary",
        children: props.children,
        variant: props.variant || "text",
        disabled: props.disabled || false,
        disabledElevation: props.disabledElevation || false,
        disableFocusRipple: props.disableFocusRipple || false,
        endIcon: props.endIcon || false,
        fullWidth: props.fullWidth || false,
        href: props.href || "",
        size: props.size || "medium",
        startIcon: props.startIcon || "",
        onClick: props.onClick || logErr(),
        selected: props.selected || false,
        trueColor: props.trueColor || "accentGreen",
        falseColor: props.falseColor || "neutralDark",
        trueClass: props.trueClass || "dynamicButton"
    });
};
